<template>
  <div id="app">
    <SiteHeader />
    <main>
      <router-view />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'

export default {
    name: 'App',
    components: { SiteHeader, SiteFooter },
    mounted() {
        this.$analytics.logEvent('Load App')
    }
}
</script>
